import React from 'react';
import { useState, useEffect } from 'react';
import Select from 'react-select';
import slates from './Slates.js';
import RadioList from './RadioButton.js';
import RadioListImage from './RadioButtonImage.js';
import { Helmet } from 'react-helmet-async';

const Home = () => {
       
    const [sport, setSport] = useState("NFL");
    const [oneVsMany, setOneVsMany] = useState("One");
    const [ddlSlates, setDdlSlates] = useState([]);
    const [ddlSlateSelected, setDdlSlateSelected] = useState("");
    const [sportMessage, setSportMessage] = useState("");
    const [emptyArray, setEmptyArray] = useState([]);

    // This 'Next' button displays when at least 1 slate is available
    //      It will take the user to a sport-specific .js page (e.g. HomeNFLFull.js if NFL full slate chosen)
    const [showNext, setShowNext] = useState(true); 

    const onChangeSport = (e) => {

        var currentDate = new Date();
        var currentdateUTC = currentDate.toUTCString(); // ALWAYS UTC -- EVERYWHERE!
        const todaysDay = currentDate.getDay(); // what day of the week is today?  returns a number 0->6
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];  // use this array to map the # above to the day's *name*

        const { name } = e.target;
        setSport(name);

        // this is the large red message above "Slate"
        //if (name === "MLB"){setSportMessage("Coming Soon");}
        //else {setSportMessage("");}

        var tempSlates = [];

        if (process.env.REACT_APP_ENVIRONMENT === 'UAT') // ignore the hide *time* (hour/minutes) in the recurring daily slates (e.g. MLB) when in UAT (helps with debugging)
        {
          tempSlates = slates.filter(slate => {return slate.sport === name && ( (slate.recurring === "" && slate.displaySlateDate <= Date.parse(currentdateUTC) && slate.hideSlateDate >= Date.parse(currentdateUTC))  ||  (slate.recurring.toUpperCase() === "YES" && slate.recurringDaysOfWeek.includes(dayNames[todaysDay]) === true && slate.displaySlateDate <= Date.parse(currentdateUTC) && slate.hideSlateDate >= Date.parse(currentdateUTC))   )   });
        }
        else // hide SuperFlex in prod (for now)
        {
            tempSlates = slates.filter(slate => {return slate.sport === name && slate.slateType === "Classic" && ( (slate.recurring === "" && slate.displaySlateDate <= Date.parse(currentdateUTC) && slate.hideSlateDate >= Date.parse(currentdateUTC))  ||  (slate.recurring.toUpperCase() === "YES" && slate.recurringDaysOfWeek.includes(dayNames[todaysDay]) === true && slate.recurringHoursStart <= currentDate.getUTCHours() && slate.recurringHoursHide >= currentDate.getUTCHours() && (slate.recurringHoursHide != currentDate.getUTCHours() || slate.recurringMinutesHide >= currentDate.getUTCMinutes()) && slate.displaySlateDate <= Date.parse(currentdateUTC) && slate.hideSlateDate >= Date.parse(currentdateUTC))   )   });
        }
        
        if (tempSlates.length > 0)
        {
            tempSlates = tempSlates.sort((a, b) => Number(a.order) - Number(b.order));
            setShowNext(true);
            setDdlSlates(tempSlates);
            setDdlSlateSelected(tempSlates[0]);
        }
        else
        {
            setDdlSlates(emptyArray);
            setDdlSlateSelected("");
            setShowNext(false);
        }


    }

    const ddlSlateChangeHandler = (value) => {
        setDdlSlateSelected(value);
    };

    const onChangeOneVsMany = (e) => {
        const { name } = e.target;
        setOneVsMany(name);
    }

    const handleNextClick = () => {
      var slateTypeUpper = String(ddlSlateSelected.slateType);
      var sportUpper = String(sport);
      slateTypeUpper = slateTypeUpper.toUpperCase();
      sportUpper = sportUpper.toUpperCase();

      if (sportUpper === 'NFL' && slateTypeUpper === 'CLASSIC')
      {
        window.location.replace('./HomeNFLFull?slateID=' + ddlSlateSelected.value.toString() + '&lineups=' + oneVsMany.toString());
      }
      else if (sportUpper === 'PGA' && slateTypeUpper === 'CLASSIC')
      {
        window.location.replace('./HomePGAFull?slateID=' + ddlSlateSelected.value.toString() + '&lineups=' + oneVsMany.toString());
      }
      else if (sportUpper === 'MLB' && slateTypeUpper === 'CLASSIC')
      {
        window.location.replace('./HomeMLBFull?slateID=' + ddlSlateSelected.value.toString() + '&lineups=' + oneVsMany.toString());
      }
      else if (sportUpper === 'NFL' && slateTypeUpper === 'SUPER')
      {
        window.location.replace('./HomeNFLSuper?slateID=' + ddlSlateSelected.value.toString() + '&lineups=' + oneVsMany.toString());
      }
    }

    // This is page load basically
    useEffect (() => {

        var currentDate = new Date();
        var currentdateUTC = currentDate.toUTCString(); // ALWAYS UTC -- EVERYWHERE!
        var tempSlates = [];
        
        const todaysDay = currentDate.getDay(); // what day of the week is today?  returns a number 0->6
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];  // use this array to map the # above to the day's *name*
        // console.log(dayNames[todaysDay]); // will be "Sunday" or "Wednesday", etc

        if (process.env.REACT_APP_ENVIRONMENT === 'UAT') // ignore the *time* (hour/minutes) in the recurring daily slates (e.g. MLB). helps w/ debugging
        {
            tempSlates = slates.filter(slate => {return slate.sport === sport &&  ( (slate.recurring === "" && slate.displaySlateDate <= Date.parse(currentdateUTC) && slate.hideSlateDate >= Date.parse(currentdateUTC))  ||  (slate.recurring.toUpperCase() === "YES" && slate.recurringDaysOfWeek.includes(dayNames[todaysDay]) === true && slate.displaySlateDate <= Date.parse(currentdateUTC) && slate.hideSlateDate >= Date.parse(currentdateUTC))   )   });
        }
        else // hide SuperFlex in prod (for now)
        {
            tempSlates = slates.filter(slate => {return slate.sport === sport && slate.slateType === "Classic" && ( (slate.recurring === "" && slate.displaySlateDate <= Date.parse(currentdateUTC) && slate.hideSlateDate >= Date.parse(currentdateUTC))  ||  (slate.recurring.toUpperCase() === "YES" && slate.recurringDaysOfWeek.includes(dayNames[todaysDay]) === true && slate.recurringHoursStart <= currentDate.getUTCHours() && slate.recurringHoursHide >= currentDate.getUTCHours() && (slate.recurringHoursHide != currentDate.getUTCHours() || slate.recurringMinutesHide >= currentDate.getUTCMinutes()) && slate.displaySlateDate <= Date.parse(currentdateUTC) && slate.hideSlateDate >= Date.parse(currentdateUTC))   )   });
        }

        if (tempSlates.length > 0)
        {
            tempSlates = tempSlates.sort((a, b) => Number(a.order) - Number(b.order));
            setDdlSlates(tempSlates);
            setDdlSlateSelected(tempSlates[0]);
            setShowNext(true);        
        }
        else 
        {setShowNext(false);}
    }, []
    );

    return (
        <div className="content">
            <Helmet>
                <title>Breezy Builder | Home Page</title>
                <meta name="description" content="Breezy Builder is a free Daily Fantasy Sports (DFS) lineup builder.."></meta>
                <meta name="keywords" content="DFS, mass enter, stacking, locking, run-back, correlation, ratings, salary"></meta>
                <link rel="canonical" href="/" />
            </Helmet>
          <div className = "home">

            <h1>Welcome to Breezy Builder!</h1>
            <h2>Rate and stack players to build 1 to 150 DFS lineups.</h2>
            <br></br>
            <h3>Sport</h3>
       
            <div className="div-flex">  
                <RadioListImage
                    name="NFL"
                    id="NFL"
                    value="NFL"
                    text="https://bbplayerimages.blob.core.windows.net/public/NFL.png"
                    title="NFL"
                    alt="NFL"
                    onChange={onChangeSport}
                    checked={sport === "NFL"}
                />
                 <RadioListImage
                  name="MLB"
                  id="MLB"
                  value="MLB"
                  text="https://bbplayerimages.blob.core.windows.net/public/MLB.png"
                  title="MLB"
                  alt="MLB"
                  onChange={onChangeSport}
                  checked={sport === "MLB"}
                />  
                <RadioListImage
                  name="PGA"
                  id="PGA"
                  value="PGA"
                  text="https://bbplayerimages.blob.core.windows.net/public/PGA.png"
                  title="PGA"
                  alt="PGA"
                  onChange={onChangeSport}
                  checked={sport === "PGA"}
                />    
            </div>
            <br></br> {
            (1===1) &&
                <div><label className='centerRedMessage'>{sportMessage}</label></div>
            }
            <h3>Slate</h3>
            <div className="div-inline">
                <Select className="custom-select" options={ddlSlates} label="Select Slate" value={ddlSlateSelected} onChange={ddlSlateChangeHandler} isSearchable={false} ></Select> 
            </div>

            <br></br>      
            <br></br>

            <h3>Number of Lineups</h3>
     
            <div className="div-flex">    
                <RadioList
                    name="One"
                    id="One"
                    value=""
                    text="One at a time"
                    onChange={onChangeOneVsMany}
                    checked={oneVsMany === "One"}
                />
                <RadioList
                   name="Many"
                   id="Many"
                   value=""
                   text="Many (File Download)"
                   onChange={onChangeOneVsMany}
                   checked={oneVsMany === "Many"}
                />  
            </div>

            {
            showNext &&
                <div className="div-flexRight">
                <button className="button" onClick={handleNextClick}>Next</button>
                </div>
            }
            
          </div>
        </div>
    );
}
export default Home;